import React, { useEffect, useState } from 'react';
import { SITE } from '../mock/data';

/**
 * Brief 1.5s splash screen shown on the FIRST load only. Uses `sessionStorage`
 * so it doesn't reappear on every route change, and CSS-only animations so it
 * doesn't block/delay the real page render underneath.
 */
export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return !sessionStorage.getItem('yup_splash_seen');
    } catch { return true; }
  });
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    // Total on-screen time ~1.6s: 1.3s glow pulse + 300ms fade-out
    const t1 = setTimeout(() => setFadingOut(true), 1300);
    const t2 = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem('yup_splash_seen', '1'); } catch {}
    }, 1600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={`yup-splash ${fadingOut ? 'yup-splash-fading' : ''}`}
      data-testid="yup-splash"
      aria-hidden="true"
    >
      <div className="yup-splash-inner">
        <img src={SITE.logo} alt="YUP" className="yup-splash-logo" />
      </div>
    </div>
  );
}
